import AdminLayout from "./layout/AdminLayout";

export default function FleetManagement() {
  return <AdminLayout />;
}
